import request from '@/utils/request1'

// 通讯录 登录
export function getUserInfo(data) {
  return request({
    url: '/addressBook/getUserInfo',
    method: 'post',
    data,
  })
}

// 通讯录 列表
export function getSearch(data) {
  return request({
    url: '/addressBook/search',
    method: 'post',
    data,
  })
}

// 通讯录 详情
export function getUserInfoByESId(data) {
  return request({
    url: '/addressBook/getUserInfoByESId',
    method: 'post',
    data,
  })
}
